import { render, staticRenderFns } from "./DirectPlacementCommissions.vue?vue&type=template&id=2bb9719b"
import script from "./DirectPlacementCommissions.vue?vue&type=script&lang=js"
export * from "./DirectPlacementCommissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports